<template>
  <div 
    v-if="tariffs?.length > 0"
    class="tariff-offers lg:container mx-auto flex flex-col gap-8 py-8 px-4 lg:px-0"
  >
    <div class="list grid gap-8 grid-cols-1 sm:grid-cols-2">
      <div
        v-for="tariff in tariffs"
        :key="tariff?.id"
      >
        <TariffOfferEntry :entry="tariff" :link-text="linkText" :link-path="linkPath"/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { Tariff } from '~~/models/Tariff/Tariff';
  interface Props {
    tariffs: Tariff[];
    linkText?: string;
    linkPath?: string;
  }

  defineProps<Props>();
</script>

<style lang="postcss" scoped>
.tariff-offers {
  & .short-description ul {
    & li {
      @apply relative flex items-center gap-2 before:w-1.5 before:h-1.5 before:inline-block before:rounded-full before:bg-black before:left-0;
    }
  }

  & a {
    @apply text-primary;
  }
}

label {
  @apply font-bold;
}
</style>